import { useSession } from '@/api/session';
import { useSessionBootstrap } from '@/api/hooks/auth';
import { AppShell } from './AppShell';
import { LoginPage } from '@/routes/LoginPage';
import { Toaster } from '@/components/ui/Toast';
import { LoadingBlock } from '@/components/ui/State';

/**
 * Коренът на приложението. Няма отделен маршрут за вход: докато няма сесия,
 * целият интерфейс е формата за вход — така не се стига до половин зареден
 * борд с празни редове.
 */
export function RootLayout() {
  useSessionBootstrap();
  const user = useSession((s) => s.user);
  const bootstrapping = useSession((s) => s.bootstrapping);

  if (bootstrapping) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingBlock />
        <Toaster />
      </div>
    );
  }

  return (
    <>
      {user ? <AppShell /> : <LoginPage />}
      <Toaster />
    </>
  );
}
